module.exports = __webpack_public_path__ + "img/blt-arrow07.1e4fc026.svg";